import React, { ReactElement, useContext, useMemo } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { ControlOutlined } from '@ant-design/icons';
import roles from '@utils/rolesConstants';
import SessionContext from '@providers/Session/SessionContext';
import { ContractActions } from '../types';

interface IContractActionsMenuProps {
  button?: ReactElement;
  loading?: boolean;
  onActionClick?: (key: {
    key: ContractActions;
    keyPath: React.Key[];
    item: React.ReactInstance;
    domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
  }) => void;
  tableSelectionIds?: any;
  style?: any;
}
const ContractActionsMenu: React.FC<IContractActionsMenuProps> = ({
  button,
  onActionClick,
  loading = false,
  tableSelectionIds = [],
  style,
}) => {
  const { t: translate } = useTranslation('customer-contracts');
  const { effectiveRoles } = useContext(SessionContext);
  const rolesToAccess = effectiveRoles?.portal;

  const menuItems = useMemo(
    () =>
      [
        {
          label: 'contracts-menu.enable-disable',
          role: roles.SMS_BLOCK,
          key: 'visibility',
          disabled: tableSelectionIds?.length === 0,
        },
        {
          label: 'contracts-menu.sms-block-apply',
          role: roles.SMS_BLOCK,
          key: 'crrBlock',
          disabled: tableSelectionIds?.length === 0,
        },
      ].filter(
        item =>
          (typeof item.role === 'boolean' && item.role) ||
          (typeof item.role === 'string' &&
            rolesToAccess?.indexOf(item.role) !== -1),
      ),

    [rolesToAccess, tableSelectionIds?.length],
  );

  const menu = (
    <Menu
      inlineIndent={8}
      onClick={({ key, keyPath, item, domEvent }) => {
        if (onActionClick) {
          onActionClick({
            key: key as ContractActions,
            keyPath,
            item,
            domEvent,
          });
        }
      }}
      disabled={tableSelectionIds?.length === 0}
    >
      <Menu.ItemGroup
        key="g1"
        title={translate('contracts-menu.contract-actions')}
      >
        {menuItems.map(menuItem => (
          <Menu.Item key={menuItem.key} disabled={menuItem.disabled}>
            {translate(menuItem.label)}
          </Menu.Item>
        ))}
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <Dropdown
      overlayClassName="overlay-menu"
      placement="bottomRight"
      overlay={menu}
      trigger={['click']}
      disabled={tableSelectionIds?.length === 0}
    >
      <div>
        {button || (
          <Button
            type="default"
            icon={<ControlOutlined />}
            loading={loading}
            style={{ ...style }}
          >
            {translate('table.actions')}
          </Button>
        )}
      </div>
    </Dropdown>
  );
};

export default ContractActionsMenu;
